/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function LockLaminatedOpen(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M207.99463,80h-108V52a28,28,0,0,1,56,0,8,8,0,0,0,16,0,44,44,0,0,0-88,0V80h-36a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,207.99463,80ZM183.99268,192H71.99463a8,8,0,0,1,0-16H183.99268a8,8,0,0,1,0,16Zm0-32H71.99463a8,8,0,0,1,0-16H183.99268a8,8,0,0,1,0,16Zm0-32H71.99463a8,8,0,0,1,0-16H183.99268a8,8,0,0,1,0,16Z" />
    </Svg>
  );
}

export default LockLaminatedOpen;
